import LocationTabs from "./location-tabs";

export default LocationTabs;